import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI, regrasPlanos } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa"

class PlanosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            descricao: '',
            programa_id: '',
            programa_nome: '',
            status: '',
            erroLoadRegistro: "",
            plano_id: "",
            titulo_pagina: "",
            loading: false,
            regras: [{ regra: '', quantidade: '', produto_id: '', produto_nome: '', servico_procedimento_id: '', servico_procedimento_nome: '', id: null }],
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        this.setState({
            plano_id: id,
            loading: true,
            erroLoadRegistro: ''
        })

        if(id){
            //consulta os dados do programa na api
            api.get(`/planos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    descricao: dados.descricao,
                    programa_id: dados.programa_id,
                    programa_nome: dados.dados_programa.nome,
                    status: dados.status,
                    loading: false,
                    titulo_pagina: 'Editando ' + dados.nome,
                })
                
                this.carregarRegrasPlano();
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar plano, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                plano_id: '',
                titulo_pagina: 'Adicionar Plano',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            descricaoHelper: "",
            programaHelper: "",
            statusHelper: "",
        });

        //vererifica se é edição ou adição
        const url = (this.state.plano_id) ? '/planos/'+this.state.plano_id+'/' : '/planos/'
        const metodo = (this.state.plano_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao);
        formData.append('programa_id', this.state.programa_id);
        formData.append('status', this.state.status);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.plano_id) ? 'Plano atualizado com sucesso' : 'Plano cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.plano_id){
                this.props.router.navigate("/planos");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o plano, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaoHelper: value })
                    }
                    if(key === 'programa_id'){
                        this.setState({ programaHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregarProgramas = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregarProdutos = async (inputValue) => {
        try {
            const response = await api.get(`/programas/produtos/?status=1&programa=${this.state.programa_id}`);
            const opcoes = response.data.results.map(produto => ({
                value: produto.produto_id,
                label: produto.dados_produto.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
            return [];
        }
    };

    carregarServicos = async (inputValue) => {
        
        try {
            const response = await api.get(`/programas/servicos_procedimentos/?status=1&programa=${this.state.programa_id}`);
            const opcoes = response.data.results.map(servico => ({
                value: servico.servico_procedimento_id,
                label: servico.dados_servico.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa_nome: label, // Atualiza o nome do programa no estado
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    //REGRAS DO PLANO
    carregarRegrasPlano = () => {
        if (this.state.plano_id) {
            api.get(`/planos/regras/?plano_id=${this.state.plano_id}`)
                .then(response => {
                    const regrasCarregadas = response.data.results.map(regra => ({
                        id: regra.id,
                        regra: regra.regra,
                        quantidade: regra.quantidade,
                        produto_id: regra.produto_id,
                        produto_nome: regra.dados_produto.nome,
                        servico_procedimento_id: regra.servico_procedimento_id,
                        servico_procedimento_nome: regra.dados_servico.nome
                    }));
                    this.setState({ regras: regrasCarregadas });
                })
                .catch(error => {
                    console.error('Erro ao carregar regras:', error);
                    
                    let erro_msg = 'Erro ao carregar regras do plano, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarRegra = (index) => {
        const regra = this.state.regras[index];
        const url = regra.id ? `/planos/regras/${regra.id}/` : '/planos/regras/';
        const metodo = regra.id ? 'put' : 'post';
    
        const dadosRegra = {
            status: true,
            regra: regra.regra,
            quantidade: regra.quantidade,
            plano_id: this.state.plano_id
        };

        if(regra.produto_id) {
            dadosRegra['produto_id'] = regra.produto_id;
        }

        if(regra.servico_procedimento_id) {
            dadosRegra['servico_procedimento_id'] = regra.servico_procedimento_id;
        }
    
        api({
            method: metodo,
            url: url,
            data: dadosRegra,
        })
        .then(response => {
            // Se for uma nova regra, atualize o estado com a ID retornada pela API
            if (!regra.id) {
                this.setState(prevState => {
                    const regrasAtualizadas = [...prevState.regras];
                    regrasAtualizadas[index].id = response.data.id;
                    return { regras: regrasAtualizadas };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (regra.id) ? 'Regra atualizada com sucesso' : 'Regra cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a regra, verifique os campos e tente novamente';      
            let content = '';      

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'regra') {
                        content += `<br>&bull; Tipo da Regra: ${value}`;
                    }
                    if(key == 'quantidade') {
                        content += `<br>&bull; Quantidade: ${value}`;
                    }
                    if(key == 'produto_id') {
                        content += `<br>&bull; Produto: ${value}`;
                    }
                    if(key == 'servico_procedimento_id') {
                        content += `<br>&bull; Serviço/Procedimento: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarRegra = () => {
        this.setState(prevState => ({
            regras: [...prevState.regras, { regra: '', quantidade: '', produto_id: '', produto_nome: '', servico_procedimento_id: '', servico_procedimento_nome: '' }],
        }));
    };

    removerRegra = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover regra?',
            text: "Tem certeza que deseja remover esta regra?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const regra = this.state.regras[index];

                if (regra.id) {

                    const url = `/planos/regras/${regra.id}/`;
                    const metodo = 'put';
                
                    const dadosRegra = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosRegra,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Regra removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            regras: prevState.regras.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a regra, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        regras: prevState.regras.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A regra foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    handleRegraChange = (index, event, fieldName) => {
        const regras = [...this.state.regras];
        if (fieldName === 'produto_id') {
            regras[index] = { ...regras[index], produto_id: event.value, produto_nome: event.label };
        } else if (fieldName === 'servico_procedimento_id') {
            regras[index] = { ...regras[index], servico_procedimento_id: event.value, servico_procedimento_nome: event.label };
        } else {
            const { name, value } = event.target;
            regras[index] = { ...regras[index], [name]: value };
        }
        this.setState({ regras });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosPlano" id="tabs-plano" className="aditus-tabs">
                    <Tab eventKey="dadosPlano" title="Dados do Plano">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Plano</h4>
                                    <Row>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Plano</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Plano" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Programa</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarProgramas}
                                                    defaultOptions
                                                    name="programa_id"
                                                    placeholder="Buscar programa..."
                                                    noOptionsMessage={() => "Nenhum programa encontrado"}
                                                    onChange={e => this.handleChange(e, 'programa_id')}
                                                    value={this.state.programa_id ? { value: this.state.programa_id, label: this.state.programa_nome } : null}
                                                />
                                                <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição do Plano</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="descricao"
                                                    value={this.state.descricao} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                                <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                                    {this.state.descricaoHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }            
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.plano_id && (
                        <Tab eventKey="regrasPlano" title="Regras do Plano">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegrasPlano}>
                                        <h4>Regras do Plano</h4>
                                        {this.state.regras.map((regra, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Regra</Form.Label>
                                                            <Form.Control as="select" name="regra" value={regra.regra} required onChange={e => this.handleRegraChange(index, e, 'regra')}>
                                                                <option value="">Tipo</option>
                                                                {Object.entries(regrasPlanos).map(([tipo, nome]) => (
                                                                    <option key={tipo} value={tipo}>{nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    {regra.regra && regra.regra == 'servicos_procedimentos' && (
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Serviço</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarServicos}
                                                                defaultOptions
                                                                name="servico_procedimento_id"
                                                                placeholder="Buscar serviço/procedimento..."
                                                                noOptionsMessage={() => "Nenhum serviço/procedimento encontrado"}
                                                                onChange={e => this.handleRegraChange(index, e, 'servico_procedimento_id')}
                                                                value={regra.servico_procedimento_id ? { value: regra.servico_procedimento_id, label: regra.servico_procedimento_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                    {regra.regra && regra.regra == 'produtos' && (
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Produto</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarProdutos}
                                                                defaultOptions
                                                                name="produto_id"
                                                                placeholder="Buscar produto..."
                                                                noOptionsMessage={() => "Nenhum produto encontrado"}
                                                                onChange={e => this.handleRegraChange(index, e, 'produto_id')}
                                                                value={regra.produto_id ? { value: regra.produto_id, label: regra.produto_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Quantidade</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="quantidade"
                                                                value={regra.quantidade} 
                                                                onChange={e => this.handleRegraChange(index, e, 'quantidade')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarRegra(index)}><FaCheck className="me-1" /> Salvar Regra</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerRegra(index)}><FaTimes className="me-1" /> Remover Regra</Button>
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarRegra}><FaStream /> Adicionar Serviço</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(PlanosEdit);